export const CLASSES = {
  HIDDEN: 'd-none',
  ACTIVE: 'active',
  NAV_ITEM_WITH_CHILDREN: 'menu-item-has-children',
  HAMBURGER_ACTIVE: 'hamburger-active',
  STICKY_NAV: 'sticky-nav',
  NAV_COLLAPSE_PARENT: 'js-nav__collapse-parent',
  TAB: {
    LIST: 'js-tab-list',
    LIST_SWITCH: 'js-tab-list__switch',
    CONTENT: 'js-tab-content',
    ACTIVE: 'current',
  },
  ACCORDION: {
    CARD: 'js-accordion-card',
    BODY: 'js-accordion-body',
  },
  BS: {
    COLLAPSE: {
      COLLAPSED: 'collapsed',
      SHOW: 'show',
    },
  },
};

export const SELECTORS = {
  HAMBURGER: '.js-hamburger',
  NAV: '#hamburger-target',
  NAV_ITEM_WITH_CHILDREN: '.menu-item-has-children',
  NAV_COLLAPSE_PARENT: '.js-nav__collapse-parent',
  SLIDERS: {
    DEFAULT: '.js-slider',
    WITH_THUMBS: '.js-slider-with-thumbs',
    ARROWS: '.splide__arrows',
    ARROW: '.splide__arrow',
  },
  TAB: {
    LIST: `.${CLASSES.TAB.LIST}`,
    LIST_SWITCH: `.${CLASSES.TAB.LIST_SWITCH}`,
    LIST_BADGE: `.${CLASSES.TAB.LIST_BADGE}`,
    LIST_SWITCH_ACTIVE: `.${CLASSES.TAB.LIST_SWITCH}.${CLASSES.TAB.ACTIVE}`,
    CONTENT: `.${CLASSES.TAB.CONTENT}`,
    CONTENT_ACTIVE: `.${CLASSES.TAB.CONTENT}.${CLASSES.TAB.ACTIVE}`,
    LIST_ITEM_ACTIVE: '.default-active',
  },
  ACCORDION: {
    CARD: `.${CLASSES.ACCORDION.CARD}`,
    BODY: `.${CLASSES.ACCORDION.BODY}`,
  },
  HERO_IMG: '.bg-img',
  SPLIT_ITEM_BG: '.split__item-bg',
  WATER_BREAK_BG: '#js-water-break__bg',
  BS: {
    COLLAPSE: '.collapse',
  },
};

export const DATA_ATTR = {
  TOGGLE: 'toggle',
  TAB: {
    ANIMATE: 'animate',
  },
  HAMBURGER: {
    TARGET: 'target',
  },
  BS: {
    COLLAPSE_TARGET: 'bs-toggle',
    COLLAPSE_PARENT: 'bsParent',
  },
  SLIDER: {
    CONFIG: 'config',
    THUMBS: 'thumbs',
  },
};

export const EVENTS = {
  HAMBURGER: {
    SHOW: 'aq.hamburger.show',
    HIDE: 'aq.hamburger.hide',
  },
  AJAX_RELOAD: 'ajax.reload',
  BS: {
    COLLAPSE: {
      SHOW: 'show.bs.collapse',
      HIDE: 'hide.bs.collapse',
    },
  },
  SPLIDE: {
    ARROWS_UPDATED: 'arrows:updated',
  },
};

export const BREAKPOINT = {
  HAMBURGER_MENU: 1024,
};

export const URL_PARAMS = {
  SLIDER_NAME: 'typ',
  SLIDER_SLIDE: 'slide'
}
